(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-grid"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (e) => {
    const button = e.target.closest('[data-load-more]');
    if (!button) return;

    e.preventDefault();

    const resultsList = button.closest('results-list');
    if (!resultsList) return;

    const sentinel = resultsList.querySelector('.load-more-sentinel');
    const grid = resultsList.querySelector('[ref="grid"]');
    if (!sentinel || !grid) return;

    const lastPage = Number(grid.dataset.lastPage) || 1;

    const observer = new MutationObserver(() => {
      observer.disconnect();
      sentinel.classList.remove('load-more-sentinel--visible');

      const updatedCards = resultsList.querySelectorAll('[ref="cards[]"]');
      const updatedLastCard = updatedCards[updatedCards.length - 1];
      const newPage = updatedLastCard ? Number(updatedLastCard.dataset.page) : 0;

      if (newPage >= lastPage) {
        const wrapper = button.closest('.load-more-wrapper');
        if (wrapper) wrapper.style.display = 'none';
      }
    });

    observer.observe(grid, { childList: true });

    requestAnimationFrame(() => {
      sentinel.classList.add('load-more-sentinel--visible');
    });

    setTimeout(() => {
      sentinel.classList.remove('load-more-sentinel--visible');
      observer.disconnect();
    }, 5000);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["twp-size-guide-modal"] && !Shopify.designMode) return;
  try {
    // Open the size guide from any trigger (delegated so it works for triggers
  // added after load, e.g. inside the FoxSell product modal). Travels with the
  // modal so the feature works wherever the modal is rendered (PDP + grouped).
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-dialog-target]');
    if (!trigger) return;
    const dialog = document.getElementById(trigger.dataset.dialogTarget);
    if (dialog && typeof dialog.showDialog === 'function') dialog.showDialog();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["twp-wishlist-init"] && !Shopify.designMode) return;
  try {
    const TWP_WISHLIST_KEY = 'twp-wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(TWP_WISHLIST_KEY) || '[]');
    } catch {
      return [];
    }
  }

  function setWishlist(ids) {
    localStorage.setItem(TWP_WISHLIST_KEY, JSON.stringify(ids));
  }

  function initWishlistBtn(btn) {
    if (btn.dataset.wishlistInit) return;
    btn.dataset.wishlistInit = 'true';

    const id = String(btn.dataset.productId);
    btn.setAttribute('aria-pressed', String(getWishlist().includes(id)));

    btn.addEventListener('click', () => {
      const list = getWishlist();
      const index = list.indexOf(id);
      if (index === -1) {
        list.push(id);
        btn.setAttribute('aria-pressed', 'true');
      } else {
        list.splice(index, 1);
        btn.setAttribute('aria-pressed', 'false');
      }
      setWishlist(list);
    });
  }

  document.querySelectorAll('.twp-wishlist-btn').forEach(initWishlistBtn);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["twp-yotpo-pdp-star-rating-styles"] && !Shopify.designMode) return;
  try {
    // One-shot gate for the star-rating fade-in above: once the first fadeIn on the
  // wrapper finishes, mark it so Yotpo's post-fetch re-render (which re-triggers
  // the :has() match) can't replay the animation — that replay is the "second
  // flash" of the stars. The marker is set on animationend, after the fade has
  // fully completed, so removing the animation causes no visible change.
  document.querySelectorAll('.shopify-app-block .yotpo-widget-instance').forEach((wrapper) => {
    wrapper.addEventListener('animationend', (event) => {
      if (event.target === wrapper && event.animationName === 'fadeIn') {
        wrapper.setAttribute('data-twp-star-rating-revealed', '');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
